module.exports = __webpack_public_path__ + "img/makeup.b30a712e.png";